export const OUTLET = {
  HOME: 'outlet-home',
  CATEGORY: 'outlet-category',
  DETAIL: 'outlet-detail',
  INSPECT: 'outlet-inspect',
} as const
